export default "__VITE_ASSET__pVu2LCUc__"